import { ApiError } from './client';

/**
 * Текст ошибки обязан соответствовать причине.
 *
 * ОБОРОТНАЯ СТОРОНА ПРАВИЛА БЛОКА 6. Тогда мы закрыли молчаливые отказы: любая
 * неуспешная мутация стала видимой. Но видимой она стала ОБЩИМ текстом - и на
 * первом же боевом прохождении это стоило часа диагностики. Сервер вернул 400
 * с причиной «не пройдена проверка Turnstile», а экран показал «Не удалось
 * отправить письмо. Проверьте соединение» - и час искали почту, которой ничего
 * не было.
 *
 * Общий текст хуже молчания в одном отношении: молчание не уводит в сторону, а
 * неверный текст уводит. Поэтому правило проекта: **если сервер прислал
 * причину, показывается она; общий текст остаётся только там, где причины
 * нет** - обрыв связи, таймаут, отказ без тела.
 *
 * КАК ОТЛИЧИТЬ НАШУ ПРИЧИНУ ОТ ЧУЖОЙ. Наши отказы всегда несут пару
 * `error` (машинный код) и `message` (текст по-русски, часто с действием).
 * Better Auth отдаёт свои сообщения по-английски: показать их русскоязычному
 * стримеру - не лучше общего текста, а хуже, потому что выглядит сбоем.
 * Поэтому признак «наше» механический: строковый `error` рядом со строковым
 * `message`.
 */

interface OurFailure {
  error: string;
  message: string;
  action?: string;
}

function isOurFailure(value: unknown): value is OurFailure {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const body = value as Record<string, unknown>;
  return typeof body['error'] === 'string' && typeof body['message'] === 'string';
}

/** Собирает текст из сообщения и действия: у наших отказов есть и то и другое. */
function withAction(failure: OurFailure): string {
  return failure.action === undefined ? failure.message : `${failure.message} ${failure.action}`;
}

/**
 * Причина отказа для показа пользователю.
 *
 * `fallback` используется ТОЛЬКО когда причины нет. Если он подставился, а
 * сервер причину прислал - это дефект, тот самый, ради которого функция
 * заведена.
 */
export function reasonFrom(error: unknown, fallback: string): string {
  // Наш клиент API уже разобрал тело и сложил текст сервера в message.
  if (error instanceof ApiError) {
    return isOurFailure(error.body) ? withAction(error.body) : error.message;
  }

  if (isOurFailure(error)) {
    return withAction(error);
  }

  // Better Auth кладёт тело ответа в поле ошибки рядом со статусом.
  if (typeof error === 'object' && error !== null) {
    const candidate = (error as { body?: unknown }).body;

    if (isOurFailure(candidate)) {
      return withAction(candidate);
    }
  }

  return fallback;
}

/** Ограничение частоты - единственный статус со своим текстом на всех экранах. */
export function isRateLimited(error: unknown): boolean {
  if (error instanceof ApiError) {
    return error.status === 429;
  }

  return (
    typeof error === 'object' && error !== null && (error as { status?: number }).status === 429
  );
}
